<template>
  <div class="flex flex-col md:flex-row w-full h-full overflow-hidden">
    <div class="flex justify-center items-center w-full md:w-1/2">
      <img :src="aboutUsLeft" alt="About Us" class="max-w-full h-auto object-cover" />
    </div>
    
    <div class="flex flex-col justify-center items-center text-center text-white px-6 py-12 md:w-1/2 bg-cover bg-center" :style="{ backgroundImage: `url(${aboutUsBg})` }">
      <h2 class="text-2xl md:text-4xl font-bold mb-4">
        {{ $t('aboutus.title') }}
      </h2>
      <p class="text-sm md:text-lg whitespace-pre-line">
        {{ $t('aboutus.content') }}
      </p>
    </div>
  </div>
</template>

<script>
import aboutUsLeft from './aboutus-1.png';
import aboutUsBg from './aboutus-2.png';

export default {
  watch: {
  },
  name: 'AboutUs',
  data() {
    return {
      aboutUsLeft,
      aboutUsBg
    };
  }
};
</script>

<style scoped>
img {
  transition: transform 0.3s ease-in-out;
}
img:hover {
  transform: scale(1.05);
}
</style>
